import { t } from "../../translations";

import "../styles/section-chef.css";

import { useState } from "react";
import { GET, UPDATE } from "../constants/request-type";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";

import { CircularProgress } from "@mui/material";
import { useEffect } from "react";
import { BsKanban, BsTable } from "react-icons/bs";
import { createLogger } from "../../utils/logger";
import TableOrder from "../tables/table-order";
import { openNotificationWithIcon } from "./notification-bar";
import OrderKanbanChef from "./order-kanban-chef";

const logger = createLogger("SelectOrder");

const SelectOrder = (props) => {
  const { lang, user } = props;

  const [orderList, setOrderList] = useState([]);
  const [orderStatus, setOrderStatus] = useState("");

  const [orderPeriod, setOrderPeriod] = useState("0");

  const [load, setLoad] = useState(false);

  const [viewMode, setViewMode] = useState("table"); // "table" or "kanban"

  useEffect(() => {
    initialData();
  }, []);

  // useEffect(() => {}, [live]);

  const initialData = async () => {
    setLoad(true);
    const request_details_food = {
      type: GET,
      url: service_api,
      route: `order/get-chef-orders/${user?._id}`,
      data: null,
      token: user?.refresh_token
    };

    try {
      const response_food = await MakeRequestAsync(request_details_food);

      const decryptedDataFood = decryptSingleData(
        response_food.data.order
      );
      logger.log(decryptedDataFood);
      setOrderList([...decryptedDataFood]);
    } catch (err) {
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
    } finally {
      setLoad(false);
    }
  };

  const updateOrder = async (order_id, status) => {
    setLoad(true);
    const request_details = {
      type: UPDATE,
      url: service_api,
      route: `order/update-order-chef/${order_id}`,
      data: {
        status: status
      },
      token: user?.refresh_token
    };

    try {
      await MakeRequestAsync(request_details);
      openNotificationWithIcon("success", t("success.order_updated", lang));
      // Refresh the data instead of reloading the page
      initialData();
    } catch (err) {
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
    } finally {
      setLoad(false);
    }
  };

  function addDaysToDate(days) {
    let daysValue = parseInt(days);
    const date = new Date();
    date.setDate(date.getDate() + daysValue);
    logger.log(date);
    // Format the date back to "YYYY-MM-DD" format
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    const newDate = `${year}-${month}-${day}`;

    return newDate;
  }

  return (
    <div className="section-chef-menu-right-food">
      <div className="section-chef-menu-right-food-inside">
        {/* View Toggle */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: 20
          }}
        >
          <div
            style={{
              display: "flex",
              gap: 10,
              backgroundColor: "#f0f0f0",
              padding: 5,
              borderRadius: 8
            }}
          >
            <button
              onClick={() => setViewMode("table")}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                padding: "8px 16px",
                border: "none",
                borderRadius: 6,
                backgroundColor:
                  viewMode === "table" ? "#FF114D" : "transparent",
                color: viewMode === "table" ? "white" : "#666",
                cursor: "pointer",
                fontWeight: viewMode === "table" ? "bold" : "normal",
                transition: "all 0.3s ease"
              }}
            >
              <BsTable size={18} />
              <span>{t("order_kanban.table_view", lang) || "Table"}</span>
            </button>
            <button
              onClick={() => setViewMode("kanban")}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                padding: "8px 16px",
                border: "none",
                borderRadius: 6,
                backgroundColor:
                  viewMode === "kanban" ? "#FF114D" : "transparent",
                color: viewMode === "kanban" ? "white" : "#666",
                cursor: "pointer",
                fontWeight: viewMode === "kanban" ? "bold" : "normal",
                transition: "all 0.3s ease"
              }}
            >
              <BsKanban size={18} />
              <span>{t("order_kanban.kanban_view", lang) || "Kanban"}</span>
            </button>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between"
          }}
        >
          <div
            className="section-chef-menu-right-food-inside-filter"
            style={{
              width: "48%"
            }}
          >
            <p
              style={{
                textAlign: "left",
                fontSize: 18,
                fontWeight: 600
              }}
            >
              {t("common.date_filters", lang)}
            </p>
            <div
              style={{
                width: "100%",
                display: "flex"
              }}
            >
              <div
                style={{
                  width: "100%"
                }}
              >
                <p
                  style={{
                    textAlign: "left",
                    fontSize: 15
                  }}
                >
                  {t("common.you_can_filter_", lang)}{" "}
                </p>
                <select
                  className="select-address-box"
                  name={"orderPeriod"}
                  value={orderPeriod}
                  onChange={(e) => {
                    setOrderPeriod(e.target.value);
                  }}
                  style={{
                    width: "100%",
                    marginTop: "0"
                  }}
                >
                  {[
                    {
                      label: t(
                        "order_selection.date_filter_options.90_days_back",
                        lang
                      ),
                      value: "-90"
                    },
                    {
                      label: t(
                        "order_selection.date_filter_options.30_days_back",
                        lang
                      ),
                      value: "-30"
                    },
                    {
                      label: t(
                        "order_selection.date_filter_options.1_week_back",
                        lang
                      ),
                      value: "-7"
                    },
                    {
                      label: t(
                        "order_selection.date_filter_options.3_days_back",
                        lang
                      ),
                      value: "-3"
                    },
                    {
                      label: t(
                        "order_selection.date_filter_options.today",
                        lang
                      ),
                      value: "0"
                    },
                    {
                      label: t(
                        "order_selection.date_filter_options.next_3_days",
                        lang
                      ),
                      value: "3"
                    },
                    {
                      label: t(
                        "order_selection.date_filter_options.next_1_week",
                        lang
                      ),
                      value: "7"
                    },
                    {
                      label: t(
                        "order_selection.date_filter_options.next_20_days",
                        lang
                      ),
                      value: "20"
                    }
                  ].map((item) => (
                    <option value={item.value}>{item.label}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div
            className="section-chef-menu-right-food-inside-filter"
            style={{
              width: "48%"
            }}
          >
            <p
              style={{
                textAlign: "left",
                fontSize: 18,
                fontWeight: 600
              }}
            >
              {t("common.status_filters", lang)}
            </p>
            <div
              style={{
                width: "100%",
                display: "flex"
              }}
            >
              <div
                style={{
                  width: "100%"
                }}
              >
                <p
                  style={{
                    textAlign: "left",
                    fontSize: 15
                  }}
                >
                  {t("commerce.you_can_filter_", lang)}{" "}
                </p>
                <select
                  className="select-address-box"
                  name={"orderStatus"}
                  value={orderStatus}
                  onChange={(e) => {
                    setOrderStatus(e.target.value);
                  }}
                  style={{
                    width: "100%",
                    marginTop: 0
                  }}
                >
                  <option value="">
                    {t("order_selection.status_filter_options.all", lang)}
                  </option>
                  {[
                    {
                      label: t(
                        "order_selection.status_filter_options.pending",
                        lang
                      ),
                      value: 0
                    },
                    {
                      label: t(
                        "order_selection.status_filter_options.ready",
                        lang
                      ),
                      value: 1
                    },
                    {
                      label: t(
                        "order_selection.status_filter_options.on_way",
                        lang
                      ),
                      value: 2
                    },
                    {
                      label: t(
                        "order_selection.status_filter_options.delivered",
                        lang
                      ),
                      value: 3
                    },
                    {
                      label: t(
                        "order_selection.status_filter_options.canceled",
                        lang
                      ),
                      value: 4
                    },
                    {
                      label: t(
                        "order_selection.status_filter_options.refunded",
                        lang
                      ),
                      value: 5
                    }
                  ].map((item) => (
                    <option value={item?.value}>{item.label}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
        <div
          className="section-chef-menu-right-food-inside-filter"
          style={{
            width: "100%",
            height: "auto",
            marginTop: 30
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end"
            }}
          >
            <div
              className="btn-get-started"
              style={{
                backgroundColor: "#fff",
                color: "green",
                width: 150
              }}
              onClick={() => {
                if (load) {
                  return;
                }
              }}
            >
              {!load && t("common.export_csv_exce_4", lang)}
              {load && <CircularProgress size={25} />}
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center"
            }}
          >
            {!load && viewMode === "table" && (
              <TableOrder
                data={orderList?.filter((item) => {
                  if (orderStatus === "") {
                    return (
                      item?.billing_details.delivery_date >=
                      addDaysToDate(orderPeriod)
                    );
                  } else {
                    return (
                      item?.status === parseInt(orderStatus) &&
                      item?.billing_details.delivery_date >=
                        addDaysToDate(orderPeriod)
                    );
                  }
                })}
                updateOrder={updateOrder}
              />
            )}
            {!load && viewMode === "kanban" && (
              <OrderKanbanChef
                orders={orderList?.filter((item) => {
                  if (orderStatus === "") {
                    return (
                      item?.billing_details.delivery_date >=
                      addDaysToDate(orderPeriod)
                    );
                  }
                  if (orderStatus !== "") {
                    return (
                      item?.status === parseInt(orderStatus) &&
                      item?.billing_details.delivery_date >=
                        addDaysToDate(orderPeriod)
                    );
                  }
                })}
                updateOrder={updateOrder}
                lang={lang}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectOrder;
